import { render, staticRenderFns } from "./RdigStatusLabel.vue?vue&type=template&id=3adaa462&scoped=true&"
import script from "./RdigStatusLabel.vue?vue&type=script&lang=js&"
export * from "./RdigStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./RdigStatusLabel.vue?vue&type=style&index=0&id=3adaa462&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adaa462",
  null
  
)

export default component.exports